import api from "./axios";
import { errorMessage, tokenExpired } from "../../utils/alertMessages";

export default function setup() {
  api.interceptors.request.use(
    (config) => {
      const axiosConfig = config;
      const token = localStorage.getItem("user-access-token");
      if (token) {
        axiosConfig.headers.Authorization = `Bearer ${token}`;
        axiosConfig.headers.pragma = 'no-cache';
      }
      return axiosConfig;
    },
    (err) => Promise.reject(err),
  );

  api.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.response?.status === 401) {
        tokenExpired();
      } else if (error?.response?.status === 403 || error?.response?.status === 500) {
        errorMessage();
      }
      return Promise.reject(error);
    },
  );
}
